import { render, staticRenderFns } from "./Plan.vue?vue&type=template&id=521d6e72&scoped=true"
import script from "./Plan.vue?vue&type=script&lang=ts"
export * from "./Plan.vue?vue&type=script&lang=ts"
import style0 from "./Plan.vue?vue&type=style&index=0&id=521d6e72&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "521d6e72",
  null
  
)

export default component.exports